<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">회원정보관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>회원 ID</p>
                <input type="text" placeholder="회원 ID를 입력하세요" class="form_control" v-model="searchInfo.userId">
              </li>
              <li>
                <p>회원명</p>
                <input type="text" placeholder="회원명를 입력하세요" class="form_control" v-model="searchInfo.userNm">
              </li>
              <li>
                <p>한의원명</p>
                <input type="text" placeholder="한의원명를 입력하세요" class="form_control" v-model="searchInfo.clinicNm">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue">신규 등록</button>
            </div>
            <table class="list">
              <thead>
                <tr>
                  <th>회원 ID</th>
                  <th>회원명</th>
                  <th>별명</th>
                  <th>회원구분</th>
                  <th>한의원명</th>
                  <th>휴대전화번호</th>
                  <th>이메일</th>
                  <th>승인처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in userList" :key="index">
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.clinic_doctor_id }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.doctor_nm }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.nick_nm }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.clinic_doctor_class_nm }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.clinic_nm }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ formatPhoneNumber(item.doctor_phone_num) }}</span></td>
                  <td @click="fn_move_dtl_page(item.clinic_doctor_id)"><span>{{ item.doctor_email }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button v-if="item.approval_yn === 'N'"  :class="'bdge bd_blue'" @click="fn_approval(item.clinic_doctor_id)">승인</button>
                      <button v-else-if="item.approval_yn === 'Y'" :class="'bdge bd_white'" >승인완료</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="fn_moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'UserMngtList',
    mixins: [commonUtil],
    components: {
      Pagination
    },
    data() {
      return {
        searchInfo : {
          userId : '',
          userNm : '',
          clinicNm : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        userList: [],
        searchInfoChange : false
      }
    },
    async created(){
        //검색정보 처리
        let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
        if(searchInfoStore != null && searchInfoStore != {}){
            this.searchInfo = searchInfoStore
        }
    },
    mounted(){
      this.fn_search();
    },
    methods : {
      fn_search_change(){
        //검색 정보 변경 여부
        let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];

        console.log("@@@@ searchInfoStore : %o ",searchInfoStore)
        if(searchInfoStore != null && searchInfoStore != {}){
            if(this.searchInfo.userId != searchInfoStore.userId){
              this.searchInfoChange = true;
            }
            if(this.searchInfo.userNm != searchInfoStore.userNm){
              this.searchInfoChange = true;
            }
            if(this.searchInfo.clinicNm != searchInfoStore.clinicNm){
              this.searchInfoChange = true;
            }
        }
      },
      fn_search(){
            axios
                .post("/api/admin/userMngt/getUserInfoList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.userList = res.data.userList;

                    console.log("@@@@ userList : %o",this.userList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                    }else{
                      this.pagingShow = false; 
                    }                        

                })
                .catch((err) => console.log(err));
        },
        fn_moveGrpPage(page){
          this.searchInfo.pageInfo.page = page;
          this.fn_search();
        },
        fn_move_dtl_page(code){
            console.log("@@@@ dictionaryCd : "+code);
            this.$store.dispatch('userMngt/setClinicDoctorId', code); 
            this.$router.push({ name : 'userMngtDtl'});
      },
      fn_approval(id){
        let param = {
          clinic_doctor_id : id,
          approval_yn : 'Y'
        }

        axios
            .post("/api/admin/userMngt/updateApprovalYn", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                this.fn_search();

            })
            .catch((err) => console.log(err));
      }
    }
  }
</script>